import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useRef, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalAddDialog } from './ModalAddDialog'

type SignageAddButtonProps = {
  children: ReactNode
  title: string
  onAdd: (text: string, file: File) => void
}

export const SignageAddButton: React.FC<SignageAddButtonProps> = props => {
  const { onAdd } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setSelectedFile(file)
    }
    // 同じファイル選択のため、初期化
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = (value: string) => {
    // ファイル選択
    fileInputRef.current?.click()

    setInputValue(value)
  }

  const onClickHandler = async () => {
    handleOpen()
  }

  useEffect(() => {
    if (inputValue && selectedFile) {
      onAdd(inputValue, selectedFile)
      setInputValue('')
      setSelectedFile(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, selectedFile])

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept=".jpg, .jpeg, .png, .mp4, .JPG, .JPEG, .PNG, .MP4"
        onChange={handleFileChange}
      />
      {open && (
        <ModalAddDialog open={open} title={props.title} onClose={handleClose} onSave={handleSave} />
      )}
      <Button
        disabled={auth.isDisable}
        onClick={onClickHandler}
        startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
        sx={{
          justifyContent: 'flex-start',
          color: '#282828',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          paddingTop: '6px',
          paddingLeft: '30px',
          textAlign: 'left',
          backgroundColor: '#fff16f',
          '&:hover': {
            backgroundColor: 'rgba(255, 241, 111, 0.8)',
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '80px',
          width: '400px',
          borderRadius: '40px',
          '& .MuiSvgIcon-root': {
            fontSize: '32px',
          },
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
